export enum KycStatus {
  CLEAR = 'clear',
  REJECTED = 'rejected',
  RETRY = 'retry',
  PENDING = 'pending',
  NOT_STARTED = 'not_started',
  NO_ADDRESS = 'no_address',
}
